// Авторизация пользователя
import { apiMe } from "scripts/api/auth";
import { initLogout } from "./logout";
import { initRegAuthForms } from "./registration";
import { initSwitchAuthForm } from "./switch";
import { showUserBadge } from "./badge";

//
export const initAuth = async (onLogin?: () => void) => {
    const modal = document.getElementById("authModal");
    const errorEl = document.getElementById("authError");
    const loginInput = document.getElementById('authLoginInput');

    if (!(modal instanceof HTMLElement) || !(loginInput instanceof HTMLInputElement)) {
        throw new Error("Ошибка ! Модальное окно авторизации не найдено");
    }
    
    // Инициализируем переключение форм
    initSwitchAuthForm();
    initRegAuthForms(onLogin);
    initLogout();

    // Проверяем, что пользователь авторизирован
    const user = await apiMe();
    console.log(user);
    if (user == null){
        // Открываем модальное окно
        modal.style.display = "flex";
        loginInput.focus();
    } else{
        showUserBadge(user.login);
    }

};


export const closeAuthModal = () => {
    const modal = document.getElementById("authModal");

    if (!(modal instanceof HTMLElement)) {
        throw new Error("Ошибка ! Модальное окно авторизации не найдено");
    }

    modal.style.display = 'none';
}


/**
 * Открыть окно авторизации (например, когда сессия истекла и сервер
 * ответил 401 на защищённый запрос).
 */
export const openAuthModal = () => {
    const modal = document.getElementById("authModal");
    const loginInput = document.getElementById('authLoginInput');

    if (!(modal instanceof HTMLElement)) {
        throw new Error("Ошибка ! Модальное окно авторизации не найдено");
    }

    modal.style.display = "flex";
    if (loginInput instanceof HTMLInputElement) {
        loginInput.focus();
    }
}